export default __webpack_public_path__ + "static/media/Ballroll_00048.ad6a6d73.png";